import type { RxDocument } from 'rxdb';

import type { SearchResult } from '@/services/search-service/types';

export interface ConditionalSearchResult<T> {
  data: T[] | SearchResult[];
  isLoading: boolean;
  isSearching: boolean;
}

export const useConditionalSearch = <T>(
  searchResults: { data: SearchResult[]; isLoading: boolean },
  rxdbResults: { data: RxDocument<T>[]; isLoading: boolean },
  isSearching: boolean
): ConditionalSearchResult<T> => {
  if (isSearching) {
    return {
      data: searchResults.data,
      isLoading: searchResults.isLoading,
      isSearching: true,
    };
  }

  return {
    data: rxdbResults.data,
    isLoading: rxdbResults.isLoading,
    isSearching: false,
  };
};
